export const styles = {
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    backdropFilter: 'blur(2px)',
  },
  popover: {
    backgroundColor: '#222',
    borderRadius: 'clamp(10px, 1vw, 16px)',
    padding: 'clamp(1rem, 2vw, 2.25rem) clamp(1.5rem, 3vw, 2.75rem)',
    boxShadow: '0 8px 24px rgba(0,0,0,0.5)',
    animation: 'slideDownFade 0.4s ease',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    maxWidth: 'clamp(280px, 85vw, 340px)',
  },
  title: {
    fontSize: 'clamp(1rem, 2vw, 1.25rem)',
    fontWeight: 'bold',
    color: '#fff',
    marginBottom: 'clamp(0.5rem, 1vw, 0.75rem)',
    textAlign: 'center',
    fontFamily: 'Orbitron, sans-serif',
  },
  subtitle: {
    fontSize: 'clamp(0.75rem, 1.5vw, 0.9rem)',
    color: '#ccc',
    marginBottom: 'clamp(1rem, 2vw, 1.5rem)',
    textAlign: 'center',
    maxWidth: 'clamp(250px, 75vw, 300px)',
    whiteSpace: 'pre-line',
    fontFamily: 'Eudoxus Sans, sans-serif',
  },
  container: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'clamp(1rem, 2vw, 2rem)',
    minHeight: 'clamp(60px, 6vh, 80px)',
  },
  circle: (active, color) => ({
    width: 'clamp(12px, 1vw, 16px)',
    height: 'clamp(12px, 1vw, 16px)',
    borderRadius: '50%',
    backgroundColor: active ? color : '#666',
    transition: 'background-color 0.3s ease',
  }),
  line: (active, color) => ({
    flex: 1,
    height: '2px',
    backgroundColor: active ? color : '#666',
    transition: 'background-color 0.3s ease',
    marginTop: 'clamp(4px, 0.5vh, 7px)',
  }),
  label: {
    fontSize: 'clamp(0.6rem, 0.9vw, 0.75rem)',
    marginTop: 'clamp(0.1rem, 0.25vh, 0.25rem)',
    textAlign: 'center',
    color: '#ccc',
    whiteSpace: 'pre-line',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    height: '100%',
  },
  okButton: {
    marginTop: 'clamp(1rem, 2vh, 1.5rem)',
    backgroundColor: '#F68500',
    color: '#fff',
    border: 'none',
    padding: 'clamp(0.5rem, 1vh, 0.75rem) clamp(1.25rem, 2vw, 1.5rem)',
    borderRadius: 'clamp(4px, 1vw, 6px)',
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: 'clamp(0.8rem, 1vw, 0.9rem)',
    transition: 'background 0.3s ease',
  },
};

// Animação opcional — você pode colar isso no CSS global:
const styleSheet = document.styleSheets[0];
const keyframes = `
@keyframes slideDownFade {
  from {
    opacity: 0;
    transform: translateY(-40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`;
const alreadyExists = Array.from(styleSheet.cssRules).some(
  (rule) => rule.name === 'slideDownFade'
);
if (!alreadyExists) {
  styleSheet.insertRule(keyframes, styleSheet.cssRules.length);
}
